import { defineSlotRecipe } from '@chakra-ui/react';
import { numberInputAnatomy } from '@chakra-ui/react/anatomy';

export const numberInputRecipe = defineSlotRecipe({
  className: 'ac-numberinput',
  slots: numberInputAnatomy.keys(),
  base: {
    root: {
      display: 'flex',
      position: 'relative',

      overflow: 'hidden',
    },
    input: {
      borderColor: 'grey.light.2',
      borderWidth: '1px',
      borderStyle: 'solid',
      backgroundColor: 'bg',
      color: 'grey.dark.1',
      padding: '0 1rem',
      rounded: 'smaller',
      fontSize: '0.875rem', // 14px
      minWidth: '48px',

      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '0.5rem',

      outline: 'none',

      transitionDuration: 'faster',
      transitionTimingFunction: 'linear',
      transitionProperty: 'border-color',

      _active: {
        borderColor: 'grey.light.3',
      },

      _focus: {
        borderColor: 'grey.light.3',
      },

      _open: {
        borderColor: 'grey.light.3',
      },

      '& svg': {
        width: '1rem',
        height: '1rem',
      },
      _disabled: {
        cursor: 'disabled',
        backgroundColor: 'grey.light.0',
      },
    },
    incrementTrigger: {
      position: 'absolute',
      top: '1px',
      right: '1px',

      height: '50%',

      backgroundColor: 'white',

      borderColor: 'grey.light.2',
      borderLeftWidth: '1px',
      borderRightWidth: '0px',
      borderTopWidth: '0px',
      borderBottomWidth: '1px',
      borderStyle: 'solid',

      borderTopRightRadius: 'smaller',

      width: '20px',

      '& svg *': {
        stroke: 'grey.light.3',
      },

      _hover: {
        '& svg *': {
          stroke: 'grey.dark.2',
        },
      },

      _disabled: {
        '& svg *': {
          stroke: 'grey.light.2',
        },
      },
    },
    decrementTrigger: {
      position: 'absolute',
      bottom: '1px',
      right: '1px',

      height: '50%',

      backgroundColor: 'white',

      borderColor: 'grey.light.2',
      borderLeftWidth: '1px',
      borderRightWidth: '0px',
      borderTopWidth: '1px',
      borderBottomWidth: '0px',
      borderStyle: 'solid',

      borderBottomRightRadius: 'smaller',

      width: '20px',

      '& svg *': {
        stroke: 'grey.light.3',
      },

      _hover: {
        '& svg *': {
          stroke: 'grey.dark.2',
        },
      },
      _disabled: {
        '& svg *': {
          stroke: 'grey.light.2',
        },
      },
    },
  },
  variants: {
    sizing: {
      'fill-width': {
        input: {
          width: '100%',
          flexGrow: 1,
        },
      },
    },
    size: {
      compact: {
        input: {
          height: '30px',
          padding: '0 0.5rem',
          borderRadius: 'small',
        },
      },
      med: {
        input: {
          height: '40px',
        },
      },
      taller: {
        input: {
          height: '44px',
          padding: '8px 12px',
        },
      },
    },
    error: {
      none: {
        input: {
          borderColor: 'grey.light.2',
          _active: {
            borderColor: 'grey.light.3',
          },

          _focus: {
            borderColor: 'grey.light.3',
          },

          _open: {
            borderColor: 'grey.light.3',
          },
        },
      },
      missing: {
        input: {
          borderColor: 'halton.red',

          _active: {
            borderColor: 'halton.red',
          },

          _focus: {
            borderColor: 'halton.red',
          },

          _open: {
            borderColor: 'halton.red',
          },
        },
      },
    },
  },
  defaultVariants: {
    size: 'med',
    error: 'none',
  },
});
